/** @jsxRuntime automatic */
/** @jsxImportSource react */
import { useState } from 'react'
import { useFrame } from '@react-three/fiber'
import { EffectComposer, TiltShift2 } from '@react-three/postprocessing'
import { frame } from '../flight/state.ts'

// The tilt-shift pass that sells the ORGANIZE miniature (SPEC: "DoF pinched
// hard"). Mounted only around the god-view beat — every other beat renders
// through the plain pipeline. G6 bans bloom, not depth of field; this composer
// carries a single screen-space tilt-shift and nothing else.
export function OrganizeLens() {
  const [on, setOn] = useState(false)

  useFrame(() => {
    const inBeat = frame.p > 0.46 && frame.p < 0.66
    if (inBeat !== on) setOn(inBeat)
  })

  if (!on) return null
  return (
    <EffectComposer multisampling={0}>
      <TiltShift2 blur={0.12} taper={0.6} />
    </EffectComposer>
  )
}
